// Form validation for New Project form
import {
  plaintextValidator,
  userValidator,
  dropdownValidator
} from '../fields';
import { stringMandateConstraints } from '../utils';

const config = { mandatory: true };

export default {
  title: plaintextValidator(config),
  content: plaintextValidator({}),
  owner: userValidator(config),
  // client: dropdownValidator(config),
  site: dropdownValidator(config),
  addMilestones: {
    array: {
      name: stringMandateConstraints
    }
  }
};
